<template>
    <div>
        <div class="bids-status" v-if="hasBid">
            <div class="bidStatus">
                <span class="bid-text tag">Bid is:</span><span class="bid-status"
                                                               :class="lot.bids.length ? statusLabels[lot.bids[0].status].tagClass : ''">{{ lot.bids.length ? statusLabels[lot.bids[0].status].label : '' }}</span>
            </div>
            <div class="all-bid-status" v-if="lot.bids.length > 0">
                <div class="bid-others tag">
                    <button class="button" v-if="!bidIsOpen(lot.lot_date)" disabled style="margin-right: 5px;">All bids
                        are closed
                    </button>
                    <button class="button" disabled>Group: {{ lot.bids[0].group.name }} Max wins: {{
                        lot.bids[0].group.max_wins }} Position: {{ lot.bids[0].position }}
                    </button>
                </div>
            </div>
        </div>

        <div class="bids-section" v-if="bidIsOpen(lot.lot_date)">

            <bid-update v-if="this.lot.bids.length > 0" :bid="lot.bids[0]"></bid-update>
            <bid-place v-if="this.lot.bids.length <= 0 && userNotVisitor" :bid="lot"></bid-place>
            <bid-cancel v-if="this.lot.bids.length > 0" :bid="lot"></bid-cancel>
            <favorite-delete v-if="this.lot.favorite.length > 0" :bid="lot"></favorite-delete>
            <favorite-create v-else :bid="lot"></favorite-create>
        </div>

        <bid-modal :bid="lot"></bid-modal>
    </div>
</template>

<script>
    import BidCancel from '../../Card/Buttons/Lots/BidCancel'
    import FavoriteCreate from '../../Card/Buttons/Lots/FavoriteCreate'
    import FavoriteDelete from '../../Card/Buttons/Lots/FavoriteDelete'
    import BidModal from './BidModal.vue'
    import bidPlace from '../../Card/Buttons/Lots/BidPlace.vue'
    import bidUpdate from '../../Card/Buttons/Lots/BidUpdate.vue'
    import moment from 'moment-timezone'

    export default {
        props: ['lot'],
        components: {
            bidCancel: BidCancel,
            favoriteCreate: FavoriteCreate,
            favoriteDelete: FavoriteDelete,
            bidModal: BidModal,
            bidPlace: bidPlace,
            bidUpdate: bidUpdate
        },
        data() {
            return {
                time: null,
                statusLabels: [
                    {
                        tagClass: 'tag is-danger',
                        label: 'Canceled'
                    },
                    {
                        tagClass: 'tag is-link',
                        label: 'Active'
                    },
                    {
                        tagClass: 'tag is-success',
                        label: 'Win'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose to other'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Unsold'
                    },
                    {
                        tagClass: 'tag is-info',
                        label: 'Under negotiations'
                    },
                ],
            }
        },
        computed: {
            userNotVisitor() {
                return this.$store.getters.getUserRole !== 'Visitor'
            },
            hasBid() {
                return Array.isArray(this.lot.bids) && this.lot.bids.length > 0 === true
            }
        },
        methods: {
            bidIsOpen(lot_date) {
                return true
            }
        },
        created() {

        }
    }
</script>

<style scoped>
    .bid-status {
        margin-left: 5px;
    }

    .card {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Lot/BidBox.vue